import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Select,
} from "antd";
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { useNavigate, useParams } from "react-router";
import { ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
const { Option } = Select
const TopData = () => {
  const { confirm } = Modal;
  const { request } = useRequest();
  const tableRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listExport, setListExport] = useState([]);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [searchParams, setSearchParams] = useState({
    property_number: "",
    name: "",
    floor: "",
    email: "",
    mobile: "",
  });
  const debouncedSearchParams = useDebounce(searchParams, 300);
  const [filterValue, setFilterValue] = useState("below_5");
  const [project, setProject] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsProject, setSelectedOptionsProject] = useState([]);
  const [selectedOptionsType, setSelectedOptionsType] = useState([]);
  const propertyTypes = [
    { id: 1, name: "Apartment" },
    { id: 2, name: "Villa" },
    { id: 3, name: "Townhouse" },
    { id: 4, name: "Penthouse" },
    { id: 5, name: "Compound" },
    { id: 6, name: "Duplex" },
    { id: 7, name: "Full Floor" },
    { id: 8, name: "Half Floor" },
    { id: 9, name: "Whole Building" },
    { id: 10, name: "Bulk Rent Unit" },
    { id: 11, name: "Bungalow" },
    { id: 12, name: "Hotel & Hotel Apartment" }
  ];
  const RowDatacolumns = [

    {
      title: "Mobile Number",
      dataIndex: "_id",
      key: "_id",
      render: (_, { _id }) => {
        return <div><a href={`/search-data?search=${_id}`}>{_id ? _id : "--"}</a></div>;
      },
    },
    {
      title: "Name",
      render: (_, { first_name }) => {
        return <div>{first_name ? first_name : "-"}</div>;
      },
    },
    {
      title: "File Name",
      render: (_, { first_file_name }) => {
        return <div>{first_file_name ? first_file_name : "-"}</div>;
      },
    },

    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      render: (_, { count }) => {
        return <div>{count ? count : "--"}</div>;
      },
    },

  ]




  useEffect(() => {
    setLoading(true);
    fetchData(pagination)
    fetchLocation()
    fetchProject()
  }, [refresh, debouncedSearchText, debouncedSearchParams, filterValue, selectedOptions, selectedOptionsProject, selectedOptionsType]);


  const fetchData = (pagination, filters) => {
    const query = new URLSearchParams({
      page: pagination.current,
      limit: pagination.pageSize ?? 10,
      ...debouncedSearchParams,
    }).toString();
    let filterParam = "";
    console.log(filterValue, "filterValue")
    if (filterValue === "below_5") filterParam = "5";
    if (filterValue === "5_10") filterParam = "10";
    if (filterValue === "10_50") filterParam = "50";
    if (filterValue === "50_plus") filterParam = "50Plus";
    request({
      url: `/admin/downtown/top-data?search=${encodeURIComponent(
        debouncedSearchText || ""
      )}&${query}&filter=${filterParam}&location=${selectedOptions}&project=${selectedOptionsProject}&type=${selectedOptionsType}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        console.log(data, "data");
        setList(data.data.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.totalDocs,
          pageSize: data.data.limit
        }));
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize ?? prev.pageSize ?? 10,
    }));
    fetchData(pagination, filters);
  };
  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [pagination.current]);

  const handleFilterChange = (value) => {
    setFilterValue(value);
    setPagination({ ...pagination, current: 1 }); // Reset to page 1 when filter changes
  };

  const fetchProject = () => {
    request({
      url: `/common/project-list`,
      method: "GET",
      onSuccess: (data) => {
        setProject(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchLocation = () => {
    request({
      url: `/common/location-list`,
      method: "GET",
      onSuccess: (data) => {
        setLocationData(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeLocation = (selectedValues) => {
    setSelectedOptions(selectedValues);
  };
  const handleChangeProject = (selectedValues) => {
    setSelectedOptionsProject(selectedValues);
  };
  const handleChangeType = (selectedValues) => {
    setSelectedOptionsType(selectedValues);
  };
  const handleExport = () => {
    const rows = (listExport || []).map((row) => ({
      "Mobile Number": row?._id || "--",
      Name: row?.first_name || "-",
      "File Name": row?.first_file_name || "-",
      Count: row?.count ?? "--",
    }));

    if (!rows.length) {
      ShowToast("No data available to export", Severty.ERROR);
      return;
    }

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Top Data");
    XLSX.writeFile(workbook, `${moment().format("YYYYMMDD_HHmmss")}-TopData.xlsx`);
  };

  const fetchDataExport = () => {
    const query = new URLSearchParams({
      page: 1,
      limit: 50000,
      ...debouncedSearchParams,
    }).toString();
    let filterParam = "";
    if (filterValue === "below_5") filterParam = "5";
    if (filterValue === "5_10") filterParam = "10";
    if (filterValue === "10_50") filterParam = "50";
    if (filterValue === "50_plus") filterParam = "50Plus";

    request({
      url: `/admin/downtown/top-data?search=${encodeURIComponent(
        debouncedSearchText || ""
      )}&${query}&filter=${filterParam}&location=${selectedOptions}&project=${selectedOptionsProject}&type=${selectedOptionsType}`,
      method: "GET",
      onSuccess: (data) => {
        setListExport(data?.data?.docs || []);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchDataExport();
  }, [debouncedSearchText, debouncedSearchParams, filterValue, selectedOptions, selectedOptionsProject, selectedOptionsType]);

  return (
    <Main>
      <Row>
        <Col xs="24" md={24} lg={24} xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Top Data"
            extra={
              <>
                <Button>
                  Total Record :{pagination.total}
                </Button>
                <Button
                  type="primary"
                  icon={<ExportOutlined />}
                  onClick={handleExport}
                >
                  Export
                </Button>
                <div className="role-wrap">
                  <Select
                    filterOption={(input, option) => {
                      console.log(option.props);
                      const inputValue = input.toLowerCase();
                      const optionLabel = option.props.children.toLowerCase();
                      return optionLabel.includes(inputValue);
                    }}
                    placeholder="Select Location"
                    mode="multiple"
                    onChange={handleChangeLocation}
                  >
                    {locationData && locationData && locationData.length > 0
                      ? locationData.map((item, index) => (
                        <Option value={item._id}>{item.name}</Option>
                      ))
                      : null}
                  </Select>
                </div>
                <div className="role-wrap">
                  <Select
                    filterOption={(input, option) => {
                      console.log(option.props);
                      const inputValue = input.toLowerCase();
                      const optionLabel = option.props.children.toLowerCase();
                      return optionLabel.includes(inputValue);
                    }}
                    placeholder="Select Project"
                    mode="multiple"
                    onChange={handleChangeProject}
                  >
                    {project && project && project.length > 0
                      ? project.map((item, index) => (
                        <Option value={item._id}>{item.name}</Option>
                      ))
                      : null}
                  </Select>
                </div>
                <div className="role-wrap">
                  <Select
                    filterOption={(input, option) => {
                      console.log(option.props);
                      const inputValue = input.toLowerCase();
                      const optionLabel = option.props.children.toLowerCase();
                      return optionLabel.includes(inputValue);
                    }}
                    placeholder="Select Type"
                    onChange={handleChangeType}
                  >
                    {propertyTypes && propertyTypes && propertyTypes.length > 0
                      ? propertyTypes.map((item, index) => (
                        <Option value={item.name}>{item.name}</Option>
                      ))
                      : null}
                  </Select>
                </div>

              </>
            }
          >
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col>
                <Select
                  defaultValue={filterValue}
                  style={{ width: 200 }}
                  onChange={handleFilterChange}
                  placeholder="Filter by Count"
                >
                  {/* <Option value="">All</Option> */}
                  <Option value="below_5">Below 5</Option>
                  <Option value="5_10">5 to 10</Option>
                  <Option value="10_50">10 to 50</Option>
                  <Option value="50_plus">50+</Option>
                </Select>
              </Col>
            </Row>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={RowDatacolumns}
                dataSource={list}
                pagination={pagination}
                onChange={handleChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>
    </Main>
  );
};

export default TopData;
